import {
  Button,
  Flex,
  FormInput,
  Heading,
  IconButton,
  Text,
} from '@sparrowengg/twigs-react';
import { ChevronLeftIcon, ChevronRightIcon } from '@sparrowengg/twigs-react-icons';
import FileUploads from 'features/apps/add-apps/components/file-uploads';
import { urlRegex } from 'features/webhook/constants';
import { WebhookAppDetailsProps } from 'features/webhook/types';
import { useNavigate } from 'react-router-dom';

const AppDetails = ({
  getValues,
  setValue,
  proceedHandler,
  register,
  errors,
  handleSubmit
}: WebhookAppDetailsProps) => {
  const navigate = useNavigate();
  return (
    <Flex flexDirection="column" gap="$20">
      <Flex justifyContent="space-between" alignItems="center" css={{ position: 'relative' }}>
        <Flex flexDirection="column" gap="$2">
          <Heading size="h5">Basic Information</Heading>
          <Text size="md" css={{ color: '$neutral800' }}>
            Enter all the required fields to continue
          </Text>
        </Flex>
        <Button
          rightIcon={<ChevronRightIcon />}
          size="lg"
          onClick={handleSubmit(() => {
            proceedHandler();
          })}
          disabled={!!Object.keys(errors).length}
        >
          Endpoint Validation
        </Button>
        <IconButton
          icon={<ChevronLeftIcon />}
          size="lg"
          variant="ghost"
          css={{ position: 'absolute', left: '-$30', top: 0 }}
          onClick={() => navigate('/?tab=Webhook')}
        />
      </Flex>
      <Flex alignItems="flex-start">
        <FileUploads getValues={getValues} setValue={setValue} isWebhookApp />
        <Flex
          flexDirection="column"
          gap="$8"
          css={{ maxWidth: '720px', width: '100%' }}
        >
          <FormInput
            size="lg"
            label="App Name"
            requiredIndicator
            {...register('appName', { required: 'App Name is required' })}
            placeholder="Ex: SurveySparrow"
            error={errors?.appName?.message}
            errorBorder={errors?.appName}
          />
          <FormInput
            size="lg"
            label="Short Description"
            requiredIndicator
            {...register('shortDescription', {
              required: 'Short Description is required'
            })}
            error={errors?.shortDescription?.message}
            errorBorder={errors?.shortDescription}
          />
          <FormInput
            size="lg"
            label="Support Email"
            requiredIndicator
            placeholder="Ex: sample@surveysparrow.com"
            {...register('supportEmail', {
              required: 'Email Address is required',
              validate: {
                matchPattern: (email: string) =>
                  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                    email
                  ) || 'Support Email should be a valid address'
              }
            })}
            error={errors?.supportEmail?.message}
            errorBorder={errors?.supportEmail}
          />
          <FormInput
            size="lg"
            label="Support URL"
            placeholder="Ex: https://support.sample.com"
            error={errors?.supportUrl?.message}
            errorBorder={errors?.supportUrl}
            {...register('supportUrl', {
              pattern: {
                value: urlRegex,
                message: 'Please enter a valid URL'
              }
            })}
          />
          <FormInput
            size="lg"
            label="Website Link"
            placeholder="Ex: https://sample.com"
            error={errors?.websiteLink?.message}
            errorBorder={errors?.websiteLink}
            {...register('websiteLink', {
              pattern: {
                value: urlRegex,
                message: 'Please enter a valid Website Link'
              }
            })}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AppDetails;
